import ApiService from './ApiService';

const ObtenerMontoACobrar = (data) => {
    return ApiService.post(
        `${process.env.REACT_APP_APIPAYWALL}Venta/ObtenerMontoACobrar`,
        data
    );
};

export default ObtenerMontoACobrar;